module.exports = __webpack_public_path__ + "img/heartest.f784c22c.png";